module.exports = __webpack_public_path__ + "name=img/node_modules/html5-device-mockups/device-mockups/iPad/portrait_black.png?4357d54d57f53d6fa1e9e4962d5935c9";